import { render, staticRenderFns } from "./DisplayValueField.vue?vue&type=template&id=47fe525d&"
import script from "./DisplayValueField.vue?vue&type=script&lang=js&"
export * from "./DisplayValueField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports